import { useNavigate } from "react-router-dom";
import "./not_found.css";
import { Helmet } from "react-helmet";

function FileNotFound() {
    const navigator = useNavigate();
    return (
        <div className="not-found">
            <Helmet>
                <title>Page Not Found</title>
            </Helmet>
            <h1>Error</h1>
            <p className="zoom-area">The page you are looking for is <b>Not Found</b></p>
            <section className="error-container">
                <span className="four"><span className="screen-reader-text">4</span></span>
                <span className="zero"><span className="screen-reader-text">0</span></span>
                <span className="four"><span className="screen-reader-text">4</span></span>
            </section>
            <div className="link-container">
                <span onClick={() => { navigator("/dashboard"); }} style={{ cursor: "pointer" }} className="more-link">Home Page</span>
            </div>
        </div>
    );
}

export default FileNotFound;